import { useMutation } from "@tanstack/react-query";
import type { AxiosError } from "axios";
import { useNavigate } from "react-router-dom";

import { toast } from "@krea/shared/design-system/utils/toast";

import { createTestLenderApplication } from "../../api";
import type { ICreateTestLenderApplicationInput } from "../../types/lender-application";

type IMutationResult = Awaited<ReturnType<typeof createTestLenderApplication>>;

interface IMutationInput {
  lenderCompanyId: number;
  data?: ICreateTestLenderApplicationInput;
}

export const useCreateTestLenderApplicationMutation = () => {
  const navigate = useNavigate();

  return useMutation<IMutationResult, AxiosError, IMutationInput>({
    mutationFn: ({ lenderCompanyId, data }) =>
      createTestLenderApplication(lenderCompanyId, data),
    onSuccess: (response, { lenderCompanyId }) => {
      navigate(
        `/lender-company/${lenderCompanyId}/lender-application/${response.id}`,
      );
    },
    onError: () => {
      toast.error("Failed creating loan application for testing");
    },
  });
};
